import { Lock } from 'lucide-react';

interface LockedDashboardCardProps {
  /** Nombre de la sección bloqueada, mostrado bajo el ícono de candado. */
  title: string;
  className?: string;
}

/**
 * Placeholder que ocupa el mismo espacio que la tarjeta real del Dashboard cuando
 * el rol actual no tiene permiso para verla. Mantiene el layout estable (sin
 * reacomodo de columnas) en vez de omitir la tarjeta.
 */
export function LockedDashboardCard({ title, className = '' }: LockedDashboardCardProps) {
  return (
    <div
      className={`relative overflow-hidden rounded-xl bg-white dark:bg-surface-secondary border-[0.5px] border-[#E8E6F8] dark:border-theme-light h-full min-h-[140px] ${className}`}
    >
      <div className="p-4 blur-[3px] select-none pointer-events-none opacity-70" aria-hidden="true">
        <div className="h-2.5 w-20 bg-[#DEDAF2] dark:bg-theme-light rounded mb-3" />
        <div className="h-5 w-16 bg-[#DEDAF2] dark:bg-theme-light rounded mb-3" />
        <div className="h-2 w-full bg-[#DEDAF2] dark:bg-theme-light rounded mb-1.5" />
        <div className="h-2 w-2/3 bg-[#DEDAF2] dark:bg-theme-light rounded mb-1.5" />
        <div className="h-2 w-4/5 bg-[#DEDAF2] dark:bg-theme-light rounded" />
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-white/50 dark:bg-surface-secondary/60">
        <div className="w-8 h-8 rounded-full bg-white dark:bg-theme shadow-sm flex items-center justify-center">
          <Lock size={14} className="text-[#888780] dark:text-theme-tertiary" />
        </div>
        <p className="text-[11px] font-medium text-[#6E6C66] dark:text-theme-tertiary text-center px-3">{title}</p>
        <p className="text-[10px] text-[#A5A39C] dark:text-theme-tertiary">Sin acceso</p>
      </div>
    </div>
  );
}
